import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { injectRuntimeConfig } from '../core/config/runtime-config.token';

@Injectable({ providedIn: 'root' })
export class AirConditioningCsvService {
  private readonly http = inject(HttpClient);
  private readonly runtimeConfig = injectRuntimeConfig();

  readonly driverIds = signal<ReadonlySet<string>>(new Set<string>());

  private loadingPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = this.fetchDriverIds();
    return this.loadingPromise;
  }

  hasDriverId(driverId: string | number | null | undefined): boolean {
    if (driverId === null || driverId === undefined || driverId === '') {
      return false;
    }

    return this.driverIds().has(String(driverId));
  }

  private async fetchDriverIds(): Promise<void> {
    const csv = await firstValueFrom(
      this.http.get(this.runtimeConfig.assets.airConditioningCsvPath, {
        responseType: 'text'
      })
    );

    this.driverIds.set(parseAirConditioningCsv(csv));
  }
}

export function parseAirConditioningCsv(csv: string): ReadonlySet<string> {
  const lines = csv
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length <= 1) {
    return new Set<string>();
  }

  const driverIds = new Set<string>();

  for (const line of lines.slice(1)) {
    const [userId] = line.split(',').map((value) => value.trim());

    if (!userId) {
      continue;
    }

    driverIds.add(userId);
  }

  return driverIds;
}
